import { PROJECT_PERMISSION } from '~/modules/common/enums';

export const hasProposeActionAllowed = ({ permissionsMap, userAccessRoles }) =>
  Boolean(
    permissionsMap[
      'urn:replicon:resource-assignment-action:edit-resource-assignments'
    ] &&
      userAccessRoles.includes(
        'urn:replicon:user-data-access-level:resource-manager'
      )
  );

export const hasAcceptActionAllowed = ({ permittedActionUris }) =>
  permittedActionUris.includes(PROJECT_PERMISSION.EDIT_PROJECT) &&
  permittedActionUris.includes(PROJECT_PERMISSION.EDIT_TEAM);
